export default __webpack_public_path__ + "static/media/SportKLS_LateralDer.94678e4e.webp";